<template>
  <div class="ticketCard">
    <!-- 票信息 -->
    <div class="ticket">
      <!-- 图片 -->
      <div class="ticket-img">
        <img :src="eventImg" />
      </div>
      <!-- 详情 -->
      <div class="ticketInfo">
        <!-- 名字和金额 -->
        <div class="ticketInfo-title">
          <a class="ticket-name" :href="`/eventDetail?event=${eventInfo.id}`">
            {{ eventInfo.name }}
          </a>
          <span class="ticket-price">HK${{ totalPrice }}</span>
        </div>
        <p class="ticket-venue">
          <span class="title">{{ $t('basket-venue-title') }}：</span>
          <span class="value">{{ eventInfo.venue_name }}</span>
        </p>
        <p class="ticket-time">
          <span class="title">{{ $t('basket-date-title') }}：</span>
          <span class="value">{{ dateLabel }}</span>
        </p>
        <p class="ticket-number">
          <span class="title">{{ $t('basket-quantity-title') }}：</span>
          <span class="title">{{ totalQty }}</span>
        </p>
        <div class="ticket-tools">
          <!-- 座位资料 -->
          <a-button class="ticket-seat-info" type="link" size="small"  @click="seatInfoVisible = !seatInfoVisible">
            {{ $t('seat-details-title') }}
            <a-icon type="up" v-show="seatInfoVisible"/>
            <a-icon type="down" v-show="!seatInfoVisible"/>
          </a-button>
          <!-- <div class="ticket-btn-wrap">
            <a-button class="remove-btn" type="link" size="small">
              {{ $t('remove-title') }}
            </a-button>
          </div> -->
        </div>
      </div>
    </div>
    <!-- 座位 -->
    <div class="seat" v-show="seatInfoVisible">
      <!-- 标题 -->
      <a-row class="seat-header">
        <a-col :span="10">
          {{ $t('section-title') }}
        </a-col>
        <a-col :span="3">
          {{ $t('row-title') }}
        </a-col>
        <a-col :span="4">
          {{ $t('seat-title') }}
        </a-col>
      </a-row>
      <!-- 内容 -->
      <a-row
        class="seat-item"
        v-for="(item, index) in seats"
        :key="index"
      >
        <a-col :span="10">
          {{ showSeatInfoLabel(item, 0) }}
        </a-col>
        <a-col :span="3">
          {{ showSeatInfoLabel(item, 1) }}
        </a-col>
        <a-col :span="4">
          {{ showSeatInfoLabel(item, 2) }}
        </a-col>
        <a-col :span="7">
          <!-- {{ getName(item, 'ticketType') }} HK${{ $amountRule(item.originalPrice) }} -->
        </a-col>
        <a-col :span="8">
          <!-- <a-button class="lookSeat-btn" type="link" size="small">
            {{ $t('view-seat-plan') }}
          </a-button> -->
        </a-col>
      </a-row>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import NP from 'number-precision'
export default {
  props: {
    seats: {
      type: Array,
      default: () => []
    },
    info: {
      type: Object,
      default: () => ({})
    },
    eventInfo: {
      type: Object,
      default: () => ({})
    },
    eventImg: {
      type: String,
      default: ''
    },
    dateLabel: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      // i18nWeekField: ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'],
      seatInfoVisible: true
    }
  },
  computed: {
    ...mapState(['eventDates']),
    totalPrice () {
      let totalPrice = this.info.citylinePrices.reduce((total, item) => {
        return NP.plus(total, NP.times(Number(item.citylinePrice), item.qty))
      }, 0)
      totalPrice = NP.round(totalPrice, 2).toFixed(2)
      const totalPriceArr = totalPrice.split('.')
      return totalPriceArr[0].toLocaleString('en-US') + '.' + totalPriceArr[1]
    },
    totalQty () {
      return this.info.citylinePrices.reduce((total, item) => {
        return total + item.qty
      }, 0)
    }
  },
  methods: {
    showSeatInfoLabel (seatStr, number) {
      /*
        example tc: 區域 200, 行 K, 座位 211
        example sc: 区域 200, 行 K, 座位 211
        example en: Section 200, Row G, SEAT 202
        number=0: section
        number=1: row
        number=2: seat
      */
      const sectionArr = seatStr.split(', ')
      if (!sectionArr[number]) {
        return ''
      }
      const labelArr = sectionArr[number].split(' ')
      return labelArr[1] || ''
    }
  }
}
</script>

<style lang="scss" scoped>
.ticketCard {
  margin-bottom: 20px;
  padding: 15px 0;
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid #eee;
  .ticket {
    display: flex;
    .ticket-img {
      width: 90px;
      margin-right: 10px;
    }
  }
  .seat {
    @include background_color('seat-box-bgc');
    margin-top: 10px;
    padding: 10px;
    font-size: 0.875rem;
    .seat-header {
      @include font_color('black15-font_color');
    }
    .seat-item {
      @include font_color('ant-step-color');
      .lookSeat-btn {
        white-space: break-spaces;
      }
    }
  }
}
.ticketInfo {
  flex: 1;
  display: flex;
  flex-direction: column;
  .ticketInfo-title {
    display: flex;
    justify-content: space-between;
    margin-bottom: 0.75rem;
    .ticket-name {
      font-size: 1rem;
    }
    .ticket-price {
      @include font_color('black15-font_color');
      font-size: 1.3125rem;
      font-weight: 700;
      line-height: 1.5625rem;
    }
  }
  .ticket-venue,
  .ticket-time,
  .ticket-number {
    margin: 0;
    padding: 0;
    font-size: 0.75rem;
    .title {
      @include font_color('black15-font_color');
    }
    .value {
      @include font_color('ant-step-color');
    }
  }
  .ticket-tools {
    display: flex;
    justify-content: space-between;
    .ticket-seat-info {
      margin: 0;
      padding: 0;
      font-size: 0.75rem;
      > i {
        margin-left: 2px;
      }
    }
    .edit-btn,
    .remove-btn {
      margin: 0;
      font-weight: bold;
      font-size: 1rem;
      margin-left: 0.9375rem;
    }
  }
}

.ticket-img img {
  width: 100%;
}
</style>
